const ExternalLinkButton = ({ color = 'blue', href = '', icon, children }) => (
    <a href={href} className={`button ${color}`} target="_blank" rel="noopener noreferrer">
        {icon && <i className={`icon far fa-fw fa-${icon}`}></i>}
        <span className="text">{children}</span>
    </a>
);

export default ExternalLinkButton;
